module.exports = __webpack_public_path__ + "406c032c2a9f512078d8b812ec7728f8.svg";